 
export default  function saveIDInLocalStorageOfPublishProduct(detail,id) {
   localStorage.setItem('publishing',detail)
   localStorage.setItem('publishingId',id)
}
